import { Suspense, useEffect, useState } from "react";
import { Insureframe } from "../components/Insureframe/Insureframe";
import Loader from "../common/Loader/Loader";

export default function HousePage() {
  const broker = import.meta.env.VITE_BROKER;
  const [data, setData] = useState();

  useEffect(() => {
    async function fetchData() {
      try {
        if (!broker) {
          console.error("Missing VITE_BROKER");

          return;
        }

        const module = await import(
          `../data/${broker.toLowerCase()}/markdowns/terms.md?raw`
        );

        const houseData = module?.default ?? module?.default?.default;

        if (!houseData) {
          console.error("HouseData not found in module", module);

          return;
        }

        setData(houseData);
      } catch (error) {
        console.error("Failed to load markdowns/terms.md", error);
      }
    }

    fetchData();
  }, [broker]);

  if (!data) {
    return <Loader />;
  }

  return (
    <>
      <section className="relative overflow-hidden pb-150 pt-[150px] max-md:pt-150">
        <div className="container">
          <Suspense>
            <Insureframe
              terms={data}
              product="house"
              insureframeUrl={import.meta.env.VITE_INSUREFRAME_URL}
              insureframeApiKey={import.meta.env.VITE_INSUREFRAME_APIKEY}
              insureframeCutomUrl={import.meta.env.VITE_INSUREFRAME_CUSTOM_URL}
            />
          </Suspense>
        </div>
      </section>
    </>
  );
}
